module.exports = __webpack_public_path__ + "img/chileebuscovid19_background_hero.88f54cd4.png";